<label for="search" class="sr-only">Search</label>
<div class="relative">
	<div
		class="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3"
	>
		<mat-icon
			class="scale-75 text-gray-500"
			svgIcon="heroicons_outline:magnifying-glass"
		></mat-icon>
	</div>
	<div>
		<input
			id="search"
			name="search"
			class="focus:rounded-b-none focus:ring-b-0 focus:bg-gray-50 rounded-lg block w-full border-0 py-1.5 pl-10 pr-3 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-inset sm:text-sm sm:leading-6 bg-gray-100"
			placeholder="Search..."
			type="search"
			[formControl]="searchControl"
			[matAutocomplete]="auto"
			(click)="openSearch(auto)"
		/>
		<mat-autocomplete
			[class]="'cm-search-dropdown'"
			[hideSingleSelectionIndicator]="true"
			disableRipple
			#auto="matAutocomplete"
			(closed)="onAutocompleteClosed()"
		>
			<mat-option>
				<cm-search-dropdown-option
					[results]="searchResult$ | async"
					(onClose)="closeSearch(auto)"
				></cm-search-dropdown-option>
			</mat-option>
		</mat-autocomplete>
	</div>
</div>
